import React from 'react';
import { Skeleton, TextFieldSkeletonContainer } from './styled';
import { SkeletonProps } from './types';

export const TextFieldSkeleton: React.FC<SkeletonProps & { label?: boolean }> = ({
  width = '100%',
  height = '3rem',
  radius = 'medium',
  label = false,
  ...props
}) => (
  <TextFieldSkeletonContainer>
    {label && <Skeleton width="7rem" height="1rem" style={{ marginTop: '0.3125rem' }} />}
    <Skeleton height={height} width={width} radius={radius} {...props} />
  </TextFieldSkeletonContainer>
);
